import { useCallback, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import PropTypes from 'prop-types';

import { CustomAlert } from 'src/components/CustomAlert';
import { isLocalhost } from 'src/lib/url';
import { useCurrentUser, useNotificationActions } from 'src/store';

import useStyles from './useStyles';
import useViewState from './useViewState';
import { checkRemoteTag } from './utils';

const INTERVAL_CHECK = 60 * 1000; // 1 minute

const propTypes = {
  classes: PropTypes.shape({}),
};

const defaultProps = {
  classes: null,
};

const BuildRelevanceChecker = ({ classes }) => {
  const styles = useStyles({ classes });

  const { upgradeAvailable } = useViewState();
  const notificationActions = useNotificationActions();
  const currentUser = useCurrentUser();

  useEffect(() => {
    if (isLocalhost(window.location.href) || !currentUser) {
      return undefined;
    }

    const check = () => {
      checkRemoteTag((remoteTagIsSame) => {
        if (remoteTagIsSame) {
          return;
        }

        notificationActions.displayUpgradeAvailable();
      });
    };

    check();
    const interval = setInterval(check, INTERVAL_CHECK);

    return () => clearInterval(interval);
  }, [notificationActions, currentUser]);

  const handleReload = useCallback(() => {
    window.location.reload();
  }, []);

  if (!currentUser) {
    return null;
  }

  return (
    <Snackbar
      open={upgradeAvailable}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      data-testid="BuildRelevanceChecker"
    >
      <CustomAlert
        title="New version available!"
        severity="success"
        action={
          <Button
            className={styles.buttonUpdate}
            onClick={handleReload}
            color="inherit"
            size="small"
            data-testid="BuildRelevanceChecker__UpdateButton"
          >
            Update
          </Button>
        }
      />
    </Snackbar>
  );
};

BuildRelevanceChecker.propTypes = propTypes;
BuildRelevanceChecker.defaultProps = defaultProps;

export default BuildRelevanceChecker;
